/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ hours: NonNullable<unknown> }} Admin_External_Booking_Edit_Order_Summary_Booking_Duration_HourInputs */

const en_admin_external_booking_edit_order_summary_booking_duration_hour = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Booking_Duration_HourInputs) => LocalizedString} */ (i) => {
	if (i?.hours == "1") return /** @type {LocalizedString} */ (`1 hour`);
	return /** @type {LocalizedString} */ (`${i?.hours} hours`)
	
};

const de_admin_external_booking_edit_order_summary_booking_duration_hour = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Booking_Duration_HourInputs) => LocalizedString} */ (i) => {
	if (i?.hours == "1") return /** @type {LocalizedString} */ (`1 Stunde`);
	return /** @type {LocalizedString} */ (`${i?.hours} Stunden`)
	
};

const es_admin_external_booking_edit_order_summary_booking_duration_hour = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Booking_Duration_HourInputs) => LocalizedString} */ (i) => {
	if (i?.hours == "1") return /** @type {LocalizedString} */ (`1 hora`);
	return /** @type {LocalizedString} */ (`${i?.hours} horas`)
	
};

const fr_admin_external_booking_edit_order_summary_booking_duration_hour = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Booking_Duration_HourInputs) => LocalizedString} */ (i) => {
	if (i?.hours == "1") return /** @type {LocalizedString} */ (`1 heure`);
	return /** @type {LocalizedString} */ (`${i?.hours} heures`)
	
};

const nl_admin_external_booking_edit_order_summary_booking_duration_hour = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Booking_Duration_HourInputs) => LocalizedString} */ (i) => {
	if (i?.hours == "1") return /** @type {LocalizedString} */ (`1 uur`);
	return /** @type {LocalizedString} */ (`${i?.hours} uur`)
	
};

const it_admin_external_booking_edit_order_summary_booking_duration_hour = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Booking_Duration_HourInputs) => LocalizedString} */ (i) => {
	if (i?.hours == "1") return /** @type {LocalizedString} */ (`1 ora`);
	return /** @type {LocalizedString} */ (`${i?.hours} ore`)
	
};

const pt_br2_admin_external_booking_edit_order_summary_booking_duration_hour = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Booking_Duration_HourInputs) => LocalizedString} */ (i) => {
	if (i?.hours == "1") return /** @type {LocalizedString} */ (`1 hora`);
	return /** @type {LocalizedString} */ (`${i?.hours} horas`)
	
};

const pl_admin_external_booking_edit_order_summary_booking_duration_hour = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Booking_Duration_HourInputs) => LocalizedString} */ (i) => {
	if (i?.hours == "1") return /** @type {LocalizedString} */ (`1 godzina`);
	return /** @type {LocalizedString} */ (`${i?.hours} godz.`)
	
};

const hu_admin_external_booking_edit_order_summary_booking_duration_hour = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Booking_Duration_HourInputs) => LocalizedString} */ (i) => {
	if (i?.hours == "1") return /** @type {LocalizedString} */ (`1 óra`);
	return /** @type {LocalizedString} */ (`${i?.hours} óra`)
	
};

const ro_admin_external_booking_edit_order_summary_booking_duration_hour = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Booking_Duration_HourInputs) => LocalizedString} */ (i) => {
	if (i?.hours == "1") return /** @type {LocalizedString} */ (`1 oră`);
	return /** @type {LocalizedString} */ (`${i?.hours} ore`)
	
};

/**
* | hours | output |
* | --- | --- |
* | "1" | "1 hour" |
* | * | "{hours} hours" |
*
* @param {Admin_External_Booking_Edit_Order_Summary_Booking_Duration_HourInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_order_summary_booking_duration_hour = /** @type {((inputs: Admin_External_Booking_Edit_Order_Summary_Booking_Duration_HourInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Order_Summary_Booking_Duration_HourInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_order_summary_booking_duration_hour(inputs)
	if (locale === "de") return de_admin_external_booking_edit_order_summary_booking_duration_hour(inputs)
	if (locale === "es") return es_admin_external_booking_edit_order_summary_booking_duration_hour(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_order_summary_booking_duration_hour(inputs)
	if (locale === "nl") return nl_admin_external_booking_edit_order_summary_booking_duration_hour(inputs)
	if (locale === "it") return it_admin_external_booking_edit_order_summary_booking_duration_hour(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_order_summary_booking_duration_hour(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_order_summary_booking_duration_hour(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_order_summary_booking_duration_hour(inputs)
	return ro_admin_external_booking_edit_order_summary_booking_duration_hour(inputs)
});
export { admin_external_booking_edit_order_summary_booking_duration_hour as "admin.external_booking_edit.order_summary.booking_duration_hour" }